import React from "react";
import LogoUpload from "../LogoUpload/LogoUpload";
import "../../styles/components/image-uploads.css";

const LogoTab = ({ logoUrl, handleLogoChange, logoPreviewUrl }) => {
  return (
    <div className="input-container">
      <h3 className="tab-title">Logo Image</h3>

      <LogoUpload
        logoImage={logoUrl}
        handleLogoChange={handleLogoChange}
        logoPreviewUrl={logoPreviewUrl}
      />
    </div>
  );
};

export default LogoTab;